import withCoreStyles from "@cybs-ui/components/lib/corethemedstyles";
import { ThemeProvider } from "emotion-theming";
import { themeBuilder } from "@cybs-plugins/theme";
import 'font-awesome/css/font-awesome.min.css';
import { default as React} from 'react';
import '../node_modules/react-modal-video/scss/modal-video.scss';
import HowItWorks from './rhs/dynamic/components/rhs-components/js/how-it-works';
import LiveConsole from './rhs/dynamic/components/rhs-components/js/live-console';
import RequestFieldDescription from './rhs/dynamic/components/rhs-components/js/request-field-description';
import ResponseFieldDescription from './rhs/dynamic/components/rhs-components/js/response-field-description';
import RHSHeader from './rhs/dynamic/components/rhs-components/js/rhs-header';
import './index.css';
import CustomSliderExample from './lhs/services/navigation';
import SidePanel from './rhs/dynamic/components/rhs-components/js/side-panel';
import StaticApiEndpointsSection from './rhs/static/components/static-api-endpoints-section';
import StaticHomeSection from './rhs/static/components/static-home-section';
import { getPrimarySwatch} from "./themeprovider/actions/themes-provider";


class ParentComponent extends React.Component {

    render() {
        if (this.props != undefined) {
            var theme = themeBuilder(getPrimarySwatch());
            if (theme != undefined && getPrimarySwatch()!= undefined) {
                return (<ThemeProvider theme={theme}>
                    {/* <Global styles={css`${CUSTOM_CSS}`}  /> */}
                    <div class = "api-reference" style={{ display: 'flex'}}>
                    {this.props.node.id == 'root' &&
                    <div id="nav-bar" style = {{position: "fixed", height: "100%", display: "none", top: "86px", width: "15rem"}}><CustomSliderExample /></div>
                    }
                    {this.props.node.id == 'root' &&
                    <div id="static-home-section" style={{display: 'none', marginLeft: "15rem"}}>
                        <StaticHomeSection />
                    </div>}{' '}
                    {this.props.node.id == 'root' &&
                    <div id	="static-api-endpoints-section" style={{ display: 'none', marginLeft: "15rem"}}>
                        <StaticApiEndpointsSection />
                    </div>}{' '}
                    <div id="dynamic-rhs" 
                        style={{ display: this.props.node.id == 'root' ? 'none' : 'block', marginLeft: this.props.node.id == 'root' ? '15rem' : 'unset'}} >
                    <div style={{ display: this.props.node.classList.contains('apiReferenceWidget') ? 'none' : 'block'}}>
                        <SidePanel/>
                        <RHSHeader/>
                        <HowItWorks/>
                    </div>
                    <div id="LiveConsole" style={{ display: 'flex', marginLeft:'10px',marginRight:'10px'}}>
                    <LiveConsole/>
                    </div>
                    <div id ="Request Field Description" style={{marginTop:'8px'}}>
                        <RequestFieldDescription/>
                    </div>
                    <div id ="Response Field Description" style={{marginTop:'8px'}}>
                        <ResponseFieldDescription/>
                    </div>
                    {/* <Provider store={getDevCenterDataStore()}> */}
                    {/* <LiveConsole/> */}
                    {/* </Provider> */}
                    </div>{' '}	
                    
                    {' '}
                    </div>{' '}
                </ThemeProvider>
                );
            }
            else {
                return (<div></div>);
            }

        }
        else {
            return (<div></div>);
        }
        
    }


}


export default withCoreStyles(ParentComponent);